// 2026-11-03 - FormuLearning - Step 2 급성 경구 독성(CATMoS) 소절 (이슈 #104)
// 파일 위치: frontend/src/features/step2/ToxicitySection.tsx
// 설계: ai-agent/claude/261103_#104_OPERA노랑·CATMoS/설계_261103_OPERA 물성예측 모듈 아키텍처 v1.1 §5.9.3
//
// 고객 시트 노랑 6행(VT·NT·EPA·GHS·LD50·LD50 range)과 1:1 이다. DB Search 대응값이 없고 하류(QTPP·Step 3)가
// 쓰지 않는 참고 정보라 물성 표와 분리하고 선택 버튼을 두지 않는다. 묶음 지표(AD·지수)는 시트상 비노랑이라 표시하지 않는다.
// `_toxicity` 가 없으면(옛 저장분·LD50 산출 불가) 그리지 않는다 — 예측을 다시 실행하면 채워진다.

import type { ToxicityPrediction } from '../../api/step2'

function yesNo(v: number | null): string {
  return v == null ? '—' : v === 1 ? 'Yes' : 'No'
}

function num(v: number): string {
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 })
}

export default function ToxicitySection({ toxicity }: { toxicity?: ToxicityPrediction }) {
  if (!toxicity) return null
  const t = toxicity
  const rows: [string, string, string][] = [
    ['Very Toxic (LD50 ≤ 50 mg/kg)', yesNo(t.vt), ''],
    ['Non-Toxic (LD50 > 2,000 mg/kg)', yesNo(t.nt), ''],
    ['EPA Category', t.epa == null ? '—' : String(t.epa), '1~4, 1 = 독성 가장 강함'],
    ['GHS Category', t.ghs == null ? '—' : String(t.ghs), '1~5, 5 = 가장 덜 위험'],
    [`LD50 (${t.unit || 'mg/kg'})`, num(t.ld50), '클수록 안전'],
    [`LD50 Range (${t.unit || 'mg/kg'})`, t.ld50_range ? `${num(t.ld50_range[0])} ~ ${num(t.ld50_range[1])}` : '—', ''],
  ]

  return (
    <div className="mb-4" data-testid="step2-toxicity">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">Acute Oral Toxicity (CATMoS)</h4>
      <div className="overflow-x-auto rounded border" style={{ borderColor: 'var(--border-subtle)' }}>
        <table className="w-full text-[11px]">
          <thead>
            <tr style={{ backgroundColor: 'var(--color-bg-panel)' }}>
              <th className="px-3 py-1.5 text-left font-medium text-text-secondary">Property</th>
              <th className="px-3 py-1.5 text-center font-medium text-text-secondary">AI Prediction</th>
              <th className="px-3 py-1.5 text-left font-medium text-text-secondary">비고</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, value, note]) => (
              <tr key={label} className="border-t" style={{ borderColor: 'var(--border-subtle)' }}>
                <td className="px-3 py-1.5 font-medium text-text-body">{label}</td>
                <td className="px-3 py-1.5 text-center text-text-body">{value}</td>
                <td className="px-3 py-1.5 text-[10px] text-text-muted">{note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-1 text-[10px] text-text-muted">OPERA v2.9 CATMoS 예측값(쥐 경구 투여 기준). 실측값이 아니므로 참고용입니다.</p>
    </div>
  )
}
